module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAALQAAAABCAYAAAB3yoT0AAAAIklEQVQoU2P8G+J7hgENMK/ZbIIuNqqOgWE0XBgYBns6AABEykgCf4+6MAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/common/images/productCenter/A2/z85.png
// module id = Oo5z
// module chunks = 0